<template>
<div class="userData np-marketing-analysis">
    <div class="total bgc">
        <div class="left">
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <el-tooltip content="活动的全部浏览人次，同一个人多次访问算多次" placement="top">
                            <div class="name">
                                <span>总浏览量(PV)</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-blue">{{userinfo.viewcount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip content="活动的浏览人数，同一个人多次访问算 1 次" placement="top">
                            <div class="name">
                                <span>总访问人数(UV)</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-green">{{userinfo.uviewcount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip content="活动的人均访问次数，等于总浏览量/总访问人数" placement="top">
                            <div class="name">
                                <span>平均访问量</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{userinfo.avgviewcount}}</div>
                    </div>
                </div>
            </div>
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的浏览人数'" placement="top">
                            <div class="name">
                                <span>时段浏览量</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-blue">{{summaryinfo.allviewcount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的访问人数'" placement="top">
                            <div class="name">
                                <span>时段访问人数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-green">{{summaryinfo.alluviewcount}}</div>
                    </div>
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的平均访问量'" placement="top">
                            <div class="name">
                                <span>时段平均访问量</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{summaryinfo.allavgviewcount}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="filters bgc">
                <div class="add">
                    <el-button type="danger" @click="handleQuery(1)" :class="[param.timetype!=1?'is-disabled': '']">今天</el-button>
                    <el-button type="primary" @click="handleQuery(2)" :class="[param.timetype!=2?'is-disabled': '']">昨天</el-button>
                    <el-button type="success" @click="handleQuery(3)" :class="[param.timetype!=3?'is-disabled': '']">近7天</el-button>
                    <el-button type="warning" @click="handleQuery(4)" :class="[param.timetype!=4?'is-disabled': '']">近30天</el-button>
                </div>
                <div class="search">
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" @click="handleQuery(0)">确认筛选</el-button>
                    <el-button type="success" @click="handleExport">下载表格</el-button>
                </div>
            </div>
            <div class="echert">
                <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
            </div>
        </div>
    </div>
   <div class="list">
       <div class="dateTime blod"><span class="blod">{{summaryinfo.begindate}}</span> 至 <span class="blod">{{summaryinfo.enddate}}</span></div>
       <div class="result-list btn-operate-list bgc">
           <el-table :data="tableData" style="width: 100%" border>
               <el-table-column prop="date" label="时间" class-name="center"></el-table-column>
               <el-table-column prop="viewcount" label="总访问量" class-name="center"></el-table-column>
               <el-table-column prop="uviewcount" label="访问人数" class-name="center"></el-table-column>
               <el-table-column prop="avgviewcount" label="平均访问量" class-name="center"></el-table-column>
           </el-table>
       </div>
   </div>
</div>
</template>

<script>
import LineReport from 'base/echarts/lineReport'
import {mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import {getDataSummary, getDataStatisticsByUser, exportDataStatisticsByUser} from 'api/brandBusiness'
export default {
    name: 'userData',
    data() {
        return {
            init: false,
            tableData: [],
            summaryinfo: {
                begindate: '',
                enddate: '',
                allavgviewcount: '0.00',
                alluviewcount: 0,
                allviewcount: 0
            },
            lineDatas: {id: 'userData', subText: '', xdata: [], data: [], legendAddr: 'left', formatter: '{a0}: {c0}<br />{a1}: {c1}'},
            date: [],
            datatype: 1, // 1用户统计 2订单统计 3财务统计
            param: {
                timetype: 3, // 时间类型 0自定义 1今日 2昨日 3近7日 4近30日
                eventinnerid: '',
                begindate: '',
                enddate: ''
            },
            userinfo: {
                viewcount: '', // 总浏览量PV
                uviewcount: '', //  参与人数UV
                avgviewcount: '' //  平均浏览量=总浏览量PV/参与人数UV
            }
        }
    },
    mounted() {
    },
    methods: {
        handleQuery(index) {
            if (!index && !this.date.length) {
                this.$message.error('请选择筛选日期')
                return false
            } else if (!index && !!this.date.length) {
                this.param.begindate = this.date[0]
                this.param.enddate = this.date[1]
            }
            this.param.timetype = index
            this._getTotal()
        },
        getTotal(param) {
            this.param.eventinnerid = param.eventinnerid
            if (!this.init) {
                this._getDataSummary()
                this._getTotal()
            }
        },
        handleExport() {
            this.setLoading(true)
            exportDataStatisticsByUser({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '用户数据' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getTotal() {
            this.setLoading(true)
            getDataStatisticsByUser({
                data: this.param,
                success: data => {
                    this.tableData = data.data.datalist
                    this.summaryinfo = data.data.summaryinfo
                    this.lineDatas.xdata = data.data.datelist
                    this.lineDatas.data=[]
                    this.lineDatas.data.push(
                        {
                            title: '浏览量',
                            color: '#1989FA',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.viewcountlist
                        }
                    )
                    this.lineDatas.data.push(
                        {
                            title: '访问人数',
                            color: '#67C23A',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.uviewcountlist
                        }
                    )
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getDataSummary() {
            getDataSummary({
                data: {eventinnerid: this.param.eventinnerid, datatype: this.datatype},
                success: data => {
                    this.init = true
                    this.userinfo = data.data.userinfo
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";

</style>
